import React, { useEffect, useState } from "react";
import "./Product.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { useDispatch } from "react-redux";

import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";

import { addToCart } from "../../redux/actions/cartActions";
import LikeItem from "../../components/LikeItem/LikeItem";

// findal check
function Product() {
  const [product, setProducts] = useState();
  const [selectedSize, setSelectedSize] = useState("Select Size");
  const [indexOfSku, setIndexOfSku] = useState(null);
  const [count, setCount] = useState(1);
  const { id } = useParams();
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const [relatedProduct, setRelatedProduct] = useState();

  const navigate = useNavigate();

  const topImageSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const getSingleProduct = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getProduct/${id}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        console.log(response?.data?.data?.fixProducts);
        if (response?.data?.status) {
          setProducts(response?.data?.data?.products);
          setRelatedProduct(response?.data?.data?.fixProducts);
        }
        if (response?.data?.status) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const dispatch = useDispatch();

  const checktokenan = () => {
    if (!tokena) {
      localStorage.setItem("redirectAfterLogin", `/product/${id}`);
      navigate("/login");
      return false;
    }
    return true;
  };
  const addToCartby = async (XWXG) => {
    const checkValue = await checktokenan();
    if (!checkValue) {
      return;
    }

    if (selectedSize == "Select Size") {
      toast.warn("Select Size of cloths", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }
    const data = {
      productId: product?._id,
      sku: product?.sizeDetails[indexOfSku]?.sku,
      count: count,
      size: selectedSize,
      userId: userId,
    };
    dispatch(addToCart(product?.sizeDetails[indexOfSku]?.sku));
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/addToCart`,
      method: "post",
      data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          toast.success(
            "Item added to cart! You can continue shopping or proceed to checkout.",
            {
              position: "bottom-right",
              autoClose: 5000,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
            }
          );
          if (XWXG == "BUYNOW") navigate("/cart");
          // toast.success("Cart updated", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const SetSizeOfDetails = (item, index) => {
    console.log({ item, index });
    setIndexOfSku(index);
    setSelectedSize(item.size);
  };

  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [ratingCount, setRatingCount] = useState(0);
  const [userReview, setUserReview] = useState({ content: "", rating: 0 });
  // const [editing, setEditing] = useState(true);

  const getReviewSystem = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getReviewById/${id}`,
      method: "get",
    };
    console.log(config.data);

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status == true) {
          const data = response.data;
          setReviews(data?.data?.reviews);
          setAverageRating(data?.data?.totalRating / data?.data?.ratingCount);
          setRatingCount(data?.data?.ratingCount);
          // toast.success("Product added successfully", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          //   transitions: "Zoom",
          // });
          // navigate("/wishlist");
        }

        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            //   transitions: "Zoom",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getReviewSystem();
  }, [id]);

  const handleRatingChange = (rating) => {
    setUserReview({ ...userReview, rating });
  };

  const submitReview = () => {
    if (!tokena) {
      navigate("/login");
      return;
    }

    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/addReview`,
      method: "post",
      data: {
        userId: userId, // Replace with actual userId
        reviewContent: userReview.content,
        rating: userReview.rating,
        productId: id,
      },
    };
    console.log(config.data);

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status == true) {
          const data = response.data;
          setReviews(data.data.reviews);
          setAverageRating(data.data.totalRating / data.data.ratingCount);
          setRatingCount(data?.data?.ratingCount);
          // toast.success("Product added successfully", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          //   transitions: "Zoom",
          // });
          // navigate("/wishlist");
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            //   transitions: "Zoom",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const getReviewByUserId = () => {
    const config = {
      url:
        process.env.REACT_APP_BASE_URL +
        `api/getReviewByUserId/${userId}/${id}`,
      method: "get",
    };
    console.log(config.data);

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          const reviewData = response?.data?.data[0]?.rating;
          setUserReview({ ...userReview, rating: reviewData });

          // toast.success("Product added successfully", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          //   transitions: "Zoom",
          // });
          // navigate("/wishlist");
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            //   transitions: "Zoom",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [selectedItem, setSelectedItem] = useState("item-1"); // State to manage selected radio item
  const [isBlueBackground, setIsBlueBackground] = useState(false); // State to manage background color

  useEffect(() => {
    getSingleProduct();
    getReviewByUserId();
    // window.scroll.top(0, 0);
  }, [id]);

  const renderStars = (rating, setRating) => {
    const totalStars = 5;

    return (
      <div className="card-review">
        {[...Array(totalStars)].map((_, index) => {
          const starIndex = index + 1;
          return (
            <i
              key={index}
              className={
                rating >= starIndex
                  ? "bi bi-star-fill"
                  : rating >= starIndex - 0.5
                  ? "bi bi-star-half"
                  : "bi bi-star"
              }
              onClick={() => setRating(starIndex)}
              style={{ cursor: "pointer" }}
            ></i>
          );
        })}
      </div>
    );
  };

  const [convertBigImage, setConvertBigImage] = useState();

  const [isShowImage, setIsShowImage] = useState(false);

  const OpenBigImage = (item) => {
    setConvertBigImage(item);
    setIsShowImage(true);
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const AccordionItem = ({ title, children, isActive, onClick }) => {
    return (
      <div className="accordion-item">
        <div
          className={`accordion-header ${isActive && "active"}`}
          onClick={onClick}
        >
          {title}

          {isActive ? (
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.2476 8.23741C12.15 8.13978 11.9917 8.13978 11.894 8.23741L5.53009 14.6014C5.23719 14.8943 4.76232 14.8943 4.46943 14.6014C4.17653 14.3085 4.17653 13.8336 4.46943 13.5407L10.8334 7.17675C11.5168 6.49333 12.6248 6.49333 13.3083 7.17675L19.6722 13.5407C19.9651 13.8336 19.9651 14.3085 19.6722 14.6014C19.3793 14.8943 18.9045 14.8943 18.6116 14.6014L12.2476 8.23741Z"
                fill={isActive ? "#76614d" : "#000000"}
              />
            </svg>
          ) : (
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.46938 9.39966C4.76227 9.10677 5.23715 9.10677 5.53004 9.39966L11.894 15.7636C11.9916 15.8613 12.1499 15.8613 12.2476 15.7636L18.6115 9.39966C18.9044 9.10677 19.3793 9.10677 19.6722 9.39966C19.9651 9.69256 19.9651 10.1674 19.6722 10.4603L13.3082 16.8243C12.6248 17.5077 11.5168 17.5077 10.8333 16.8243L4.46938 10.4603C4.17649 10.1674 4.17649 9.69256 4.46938 9.39966Z"
                fill="#000000"
              />
            </svg>
          )}
        </div>

        {isActive && <div className="accordion-content">{children}</div>}
      </div>
    );
  };

  const [selectedImage, setSelectedImage] = useState(0);

  // match height for left and right div in the product-first-div container
  useEffect(() => {
    const matchHeight = () => {
      setTimeout(() => {
        const leftDiv = document.querySelector(".product-left");
        const rightDiv = document.querySelector(".product-right");

        if (leftDiv && rightDiv) {
          const rightHeight = rightDiv.offsetHeight;
          leftDiv.style.height = `${rightHeight}px`;
        }
      }, 1);
    };

    // Run matchHeight when the window is fully loaded
    window.addEventListener("load", matchHeight);

    // Optionally, you can still listen for resize events if needed
    window.addEventListener("resize", matchHeight);

    // Clean up the event listeners on component unmount
    return () => {
      window.removeEventListener("load", matchHeight);
      window.removeEventListener("resize", matchHeight);
    };
  }, []);

  // share url usestate
  const [showShare, setShowShare] = useState(false);
  const shareUrl = window.location.href;

  // size guide
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  return (
    <>
      <div className="product-outer">
        <div className="main-div">
          {/* conditional rendering of the images for small screen width less than 610 to 560 */}
          <div className="slider-container">
            <div className="left-images-container">
              <div className="left-img-container">
                {product?.image?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="small-image-container"
                      onClick={() => setSelectedImage(index)}
                    >
                      <img src={item} className="small-image" />
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="right-image-container">
              <img
                src={product?.image[selectedImage]}
                alt="image"
                className="right-image"
              />
            </div>
          </div>

          {/* conditional rendering of the image for small screen widht less than 560  */}
          <div className="single-image-container">
            <Slider {...topImageSliderSettings}>
              {product?.image?.map((item, index) => {
                return (
                  <Zoom>
                    <img
                      src={item}
                      key={index}
                      alt={product?.productName}
                      className="single-image"
                    />
                  </Zoom>
                );
              })}
            </Slider>
          </div>

          <div className="product-frist-div row mt-5">
            {/* left container */}
            <div className="product-left col-sm-12 col-md-6 col-lg-7">
              <div className={`container ${isBlueBackground ? "blue" : ""}`}>
                {/* product images */}
                <div className="cards">
                  {product?.image?.map((item, index) => {
                    return (
                      <>
                        <label
                          key={index}
                          className="card"
                          onClick={() =>
                            `item-${index + 1}` === selectedItem &&
                            OpenBigImage(item)
                          }
                          htmlFor={`item-${index + 1}`}
                          id={`song-${index + 1}`}
                        >
                          <Zoom>
                            <img src={item} alt="image" className="left-img" />
                          </Zoom>
                        </label>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* right container */}
            <div className="product-right col-sm-12 col-md-6 col-lg-5">
              <div className="heading-container">
                <h4 className="w-75 mt-1 fw-bold">{product?.productName}</h4>

                <div className="col-4 wishlist">
                  <LikeItem
                    productIDdd={product?._id}
                    IsLikedIte={product?.like?.some(
                      (like) => like._id == userId
                    )}
                  />
                </div>
              </div>

              <div className="details">
                <p className="mrp-text">MRP Inclusive of all taxes</p>
                <h5 className="prise">
                  Rs. {Math.ceil(product?.price || 0)}.00/-{" "}
                </h5>

                <span>
                  {" "}
                  M.R.P :<del> {product?.higherPrice}.00/-</del>
                </span>

                <h5 className="prise prise1 mt-1">Color: {product?.color}</h5>

                <div className="size-container">
                  <h6>Sizes</h6>

                  <div className="size-box-container">
                    {product?.sizeDetails?.map((size, index) => (
                      <div
                        key={index}
                        className={`size-box  ${
                          selectedSize == size?.size ? "checked" : ""
                        }`}
                        onClick={() => {
                          SetSizeOfDetails(size, index);
                        }}
                      >
                        <p>{size?.size}</p>
                      </div>
                    ))}
                  </div>

                  <div className="size-help-container">
                    <div className="size-guide-container">
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 12.2315L19.9546 11.2769C21.3182 9.91327 22 9.23148 22 8.38426C22 7.53704 21.3182 6.85525 19.9546 5.49167L18.5083 4.04537C17.1448 2.68179 16.463 2 15.6157 2C14.7685 2 14.0867 2.68179 12.7231 4.04537L4.04537 12.7231C2.68179 14.0867 2 14.7685 2 15.6157C2 16.463 2.68179 17.1448 4.04537 18.5083L5.49167 19.9546C6.85525 21.3182 7.53704 22 8.38426 22C9.23148 22 9.91327 21.3182 11.2769 19.9546L16.2315 15"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M8.46436 8.46448L9.87857 9.87869"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M12.707 4.2218L14.1212 5.63602"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M4.22192 12.7072L5.63614 14.1214"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M6.34326 10.5858L8.46458 12.7071"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M10.5857 6.34314L12.707 8.46446"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>

                      <p onClick={togglePopup}>Size Guide</p>
                    </div>
                    {isPopupOpen && (
                      <div className="size-popup" onClick={togglePopup}>
                        <div className="gide-box">
                          <table border="1" onClick={togglePopup}>
                            <i
                              style={{
                                position: "absolute",
                                right: "-8%",
                                top: "-10%",
                                color: "red",
                                fontSize: "20px",
                                cursor: "pointer",
                              }}
                              class="bi bi-x-circle"
                              onClick={togglePopup}
                            ></i>
                            <thead>
                              <tr>
                                <th>Size</th>
                                <th>Chest</th>
                                <th>Shoulder</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>S</td>
                                <td>36-38</td>
                                <td>17</td>
                              </tr>
                              <tr>
                                <td>M</td>
                                <td>38-40</td>
                                <td>18</td>
                              </tr>
                              <tr>
                                <td>L</td>
                                <td>40-42</td>
                                <td>18.75</td>
                              </tr>
                              <tr>
                                <td>XL</td>
                                <td>42-44</td>
                                <td>19.5</td>
                              </tr>
                              <tr>
                                <td>XXL</td>
                                <td>44-46</td>
                                <td>20.5</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    <div
                      className="share-btn-container"
                      onClick={() => {
                        setShowShare(!showShare);
                      }}
                    >
                      <i class="bi bi-share"></i>
                      <p>Share</p>
                    </div>

                    {/* <div className="size-stock-container">
                      <i class="bi bi-envelope-fill"></i>

                      <p>Size out of stock?</p>
                    </div> */}
                  </div>
                </div>

                {/* conditional rendering of share container */}
                {showShare && (
                  <div className="share-container">
                    {/* facebook */}
                    <div className="share-network-btn">
                      <FacebookShareButton
                        url={shareUrl}
                        className="single-share-network-btn"
                      >
                        <FacebookIcon size={32} round />
                      </FacebookShareButton>
                    </div>

                    {/* email */}
                    <div className="share-network-btn">
                      <EmailShareButton
                        url={shareUrl}
                        className="single-share-network-btn"
                      >
                        <EmailIcon size={32} round />
                      </EmailShareButton>
                    </div>

                    {/* telegram */}
                    <div className="share-network-btn">
                      <TelegramShareButton
                        url={shareUrl}
                        className="single-share-network-btn"
                      >
                        <TelegramIcon size={32} round />
                      </TelegramShareButton>
                    </div>

                    {/* twitter */}
                    <div className="share-network-btn">
                      <TwitterShareButton
                        url={shareUrl}
                        className="single-share-network-btn"
                      >
                        <XIcon size={32} round />
                      </TwitterShareButton>
                    </div>

                    {/* whatsapp */}
                    <div className="share-network-btn">
                      <WhatsappShareButton
                        url={shareUrl}
                        className="single-share-network-btn"
                      >
                        <WhatsappIcon size={32} round />
                      </WhatsappShareButton>
                    </div>
                  </div>
                )}
              </div>

              <div className="cart-buy-container">
                <div className="cart-container">
                  <button
                    className="asas"
                    onClick={() => {
                      addToCartby("ADDTOCART");
                      window.scrollTo(0, 0);
                    }}
                  >
                    ADD TO CART
                  </button>
                </div>

                <div className="buy-now-btn">
                  <button
                    onClick={() => {
                      addToCartby("BUYNOW");
                      window.scrollTo(0, 0);
                    }}
                  >
                    BUY NOW
                  </button>

                  {/* <div className="payment-icon-container">
                    
                    <div className="payment-icon-box">
                      <svg
                        width="10px"
                        height="10px"
                        viewBox="-0.5 0 48 48"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          id="Icons"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="Color-"
                            transform="translate(-401.000000, -860.000000)"
                          >
                            <g
                              id="Google"
                              transform="translate(401.000000, 860.000000)"
                            >
                              <path
                                d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24"
                                id="Fill-1"
                                fill="#FBBC05"
                              ></path>
                              <path
                                d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333"
                                id="Fill-2"
                                fill="#EB4335"
                              ></path>
                              <path
                                d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667"
                                id="Fill-3"
                                fill="#34A853"
                              ></path>
                              <path
                                d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24"
                                id="Fill-4"
                                fill="#4285F4"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>


                    <div className="payment-icon-box">
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="2"
                      >
                        <circle
                          cx="-25.926"
                          cy="41.954"
                          r="29.873"
                          fill="#5f259f"
                          transform="rotate(-76.714 -48.435 5.641) scale(8.56802)"
                        />
                        <path
                          d="M372.164 189.203c0-10.008-8.576-18.593-18.584-18.593h-34.323l-78.638-90.084c-7.154-8.577-18.592-11.439-30.03-8.577l-27.17 8.577c-4.292 1.43-5.723 7.154-2.862 10.007l85.8 81.508H136.236c-4.293 0-7.154 2.861-7.154 7.154v14.292c0 10.016 8.585 18.592 18.592 18.592h20.015v68.639c0 51.476 27.17 81.499 72.931 81.499 14.292 0 25.739-1.431 40.03-7.146v45.753c0 12.87 10.016 22.886 22.885 22.886h20.015c4.293 0 8.577-4.293 8.577-8.586V210.648h32.893c4.292 0 7.145-2.861 7.145-7.145v-14.3zM280.65 312.17c-8.576 4.292-20.015 5.723-28.591 5.723-22.886 0-34.324-11.438-34.324-37.176v-68.639h62.915v100.092z"
                          fill="#fff"
                          fill-rule="nonzero"
                        />
                      </svg>
                    </div>


                    <div className="payment-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="15px"
                        height="15px"
                        viewBox="0 0 48 48"
                      >
                        <path
                          fill="#0d47a1"
                          d="M5.446 18.01H.548c-.277 0-.502.167-.503.502L0 30.519c-.001.3.196.45.465.45.735 0 1.335 0 2.07 0C2.79 30.969 3 30.844 3 30.594 3 29.483 3 28.111 3 27l2.126.009c1.399-.092 2.335-.742 2.725-2.052.117-.393.14-.733.14-1.137l.11-2.862C7.999 18.946 6.949 18.181 5.446 18.01zM4.995 23.465C4.995 23.759 4.754 24 4.461 24H3v-3h1.461c.293 0 .534.24.534.535V23.465zM13.938 18h-3.423c-.26 0-.483.08-.483.351 0 .706 0 1.495 0 2.201C10.06 20.846 10.263 21 10.552 21h2.855c.594 0 .532.972 0 1H11.84C10.101 22 9 23.562 9 25.137c0 .42.005 1.406 0 1.863-.008.651-.014 1.311.112 1.899C9.336 29.939 10.235 31 11.597 31h4.228c.541 0 1.173-.474 1.173-1.101v-8.274C17.026 19.443 15.942 18.117 13.938 18zM14 27.55c0 .248-.202.45-.448.45h-1.105C12.201 28 12 27.798 12 27.55v-2.101C12 25.202 12.201 25 12.447 25h1.105C13.798 25 14 25.202 14 25.449V27.55zM18 18.594v5.608c.124 1.6 1.608 2.798 3.171 2.798h1.414c.597 0 .561.969 0 .969H19.49c-.339 0-.462.177-.462.476v2.152c0 .226.183.396.422.396h2.959c2.416 0 3.592-1.159 3.591-3.757v-8.84c0-.276-.175-.383-.342-.383h-2.302c-.224 0-.355.243-.355.422v5.218c0 .199-.111.316-.29.316H21.41c-.264 0-.409-.143-.409-.396v-5.058C21 18.218 20.88 18 20.552 18c-.778 0-1.442 0-2.22 0C18.067 18 18 18.263 18 18.594L18 18.594z"
                        ></path>
                        <path
                          fill="#00adee"
                          d="M27.038 20.569v-2.138c0-.237.194-.431.43-.431H28c1.368-.285 1.851-.62 2.688-1.522.514-.557.966-.704 1.298-.113L32 18h1.569C33.807 18 34 18.194 34 18.431v2.138C34 20.805 33.806 21 33.569 21H32v9.569C32 30.807 31.806 31 31.57 31h-2.14C29.193 31 29 30.807 29 30.569V21h-1.531C27.234 21 27.038 20.806 27.038 20.569L27.038 20.569zM42.991 30.465c0 .294-.244.535-.539.535h-1.91c-.297 0-.54-.241-.54-.535v-6.623-1.871c0-1.284-2.002-1.284-2.002 0v8.494C38 30.759 37.758 31 37.461 31H35.54C35.243 31 35 30.759 35 30.465V18.537C35 18.241 35.243 18 35.54 18h1.976c.297 0 .539.241.539.537v.292c1.32-1.266 3.302-.973 4.416.228 2.097-2.405 5.69-.262 5.523 2.375 0 2.916-.026 6.093-.026 9.033 0 .294-.244.535-.538.535h-1.891C45.242 31 45 30.759 45 30.465c0-2.786 0-5.701 0-8.44 0-1.307-2-1.37-2 0v8.44H42.991z"
                        ></path>
                      </svg>
                    </div>
                  </div> */}

                  {/* right arrow icon */}
                  {/* <svg
                    width="25px"
                    height="25px"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z"
                      fill="#000000"
                    />
                  </svg> */}
                </div>
              </div>

              <div className="secondary-description-container">
                <div className="review-container">
                  <div className="star-container">
                    {renderStars(averageRating, () => {})}
                    <h6>({ratingCount > 0 ? ratingCount : 0} reviews)</h6>
                  </div>

                  <div className="user-review-container">
                    <h4 className="">We’d Love Your Feedback!</h4>

                    <div className="user-review-star-container">
                      {renderStars(userReview.rating, handleRatingChange)}

                      <button
                        className="review-button rounded-2"
                        onClick={submitReview}
                      >
                        Update Review
                      </button>
                    </div>
                  </div>

                  <div className="true-size-container">
                    <h6>True to Size</h6>

                    <div className="review-line">
                      <div className="circle"></div>

                      <div className="review-text-container">
                        <p>Small</p>
                        <p>Spot On</p>
                        <p>Large</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion">
                  <AccordionItem
                    title="Description"
                    isActive={activeIndex === 0}
                    onClick={() => handleAccordionClick(0)}
                  >
                    <p className="product-description">
                      {product?.description[0]}
                    </p>
                  </AccordionItem>

                  <AccordionItem
                    title="Information"
                    isActive={activeIndex === 1}
                    onClick={() => handleAccordionClick(1)}
                  >
                    <div className="shipping-content">
                      <div>
                        <h6>Shipping</h6>
                        <p>
                          We currently offer free shipping across India on every
                          order.
                        </p>
                      </div>

                      <div>
                        <h6>Return & exchange</h6>
                        <p>
                          If you are not satisfied with your purchase you can
                          return it to us within 14 days for an exchange or
                          refund. More info.
                        </p>
                      </div>
                    </div>
                  </AccordionItem>

                  <AccordionItem
                    title="Specifications"
                    isActive={activeIndex === 2}
                    onClick={() => handleAccordionClick(2)}
                  >
                    <div>
                      <div className="specification-content">
                        <h6>Clothing-Size: </h6>
                        <div>
                          {product?.sizeDetails?.map((item, index) => (
                            <span>{item.size}, </span>
                          ))}
                        </div>
                      </div>

                      <div className="specification-content">
                        <h6>Color: </h6>
                        <p>{product?.color}</p>
                      </div>
                    </div>
                  </AccordionItem>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        {/* related products */}
        <div className="product-lower-bottom-outer row">
          <div className="product-lower-bottom-inner">
            <div className="lower-head text-center mt-3">
              <h3>Related Products</h3>
            </div>

            <div className="container product-card-conn mt-5">
              <div className="inner-card-divv">
                {relatedProduct?.map((product) => (
                  <div key={product._id} className=" home-cards-col22 ">
                    <div className=" home-card-main222 shadow ">
                      <div className="img-div-1 ">
                        <img
                          src={product?.image[0]}
                          alt="shirt"
                          className="card-img-top"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(`/product/${product?._id}`);
                            window.scrollTo(0, 0);
                          }}
                        />
                        <div className="likeee">
                          <LikeItem
                            productIDdd={product?._id}
                            IsLikedIte={product?.like?.some(
                              (like) => like._id === userId
                            )}
                          />
                        </div>
                      </div>

                      <div className="card-body" style={{ textAlign: "start" }}>
                        <div>
                          {/* <h6 className="card-title">{product?.productName}</h6> */}
                          <h6 className="card-title">
                            {product?.productName.length > 15
                              ? `${product.productName.substring(0, 15)}...`
                              : product.productName}
                          </h6>
                          <div className="LastPriceCut mt-1">
                            <h6 className="card-text">
                              <b>Rs. {Math.ceil(product?.price || 0)}/-</b>{" "}
                              &nbsp;
                              <del> {product?.higherPrice}.00/-</del>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Product;
